<script lang="ts" setup>
defineOptions({
    name: 'WidgetProductsHistorySettings'
});

interface FormSettings
{
    settings: {
        limit: number;
    };
}

const model = defineModel<FormType<FormSettings>>();
const defaults: FormSettings['settings'] = {
    limit: 1
};

const form = computed(() => model.value);

onMounted(async () =>
{
    form.value.settings = { ...defaults, ...form.value.settings };
});

const displayOptions: Option<number>[] = [
    { value: 1, text: $t('[[[1]]]') },
    { value: 2, text: $t('[[[2]]]') },
    { value: 3, text: $t('[[[3]]]') },
    { value: 4, text: $t('[[[4]]]') },
    { value: 5, text: $t('[[[5]]]') },
    { value: 6, text: $t('[[[6]]]') },
    { value: 7, text: $t('[[[7]]]') },
    { value: 8, text: $t('[[[8]]]') },
    { value: 9, text: $t('[[[9]]]') },
    { value: 10, text: $t('[[[10]]]') }
];

async function validate()
{
    form.value.validate(schema => ({
        settings: schema.object({
            limit: schema.number().required($t('[[[Wybranie limitu jest wymagane]]]')).typeError($t('[[[Wybranie limitu jest wymagane]]]'))
        })
    }));
}

watch(() => form.value.settings.limit, () =>
{
    form.value.$errors.clear('settings.limit');
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup>
        <IdeoFormGroup :label="$t('[[[Maksymalna liczba produktów]]]')" :invalid-feedback="form.$errors.first('settings.limit')" :state="form.$errors.state('settings.limit')">
            <IdeoFormSelect v-model="form.settings.limit" :options="displayOptions" />
        </IdeoFormGroup>
    </IdeoFormGroup>
</template>
